







































import { Component, Vue } from 'vue-property-decorator';
import SlideIn from "@/components/basic/SlideIn.vue";
import {
  PublicHolidayGroupEditModel,
  PublicHolidayGroupFilter,
  PublicHolidayGroupViewModel
} from "@/services/api/nswag/stapiclient_generated";
import { stPublicHolidayGroupApi } from "@/services/st-api";
import { notifySuccess } from "@/utlitities/notifications";

@Component({
  components: {
    SlideIn
  },
})
export default class PublicHolidayGroupEditSlideOut extends Vue {
  listPage: string = 'PublicHolidayGroupEdit';
  id: number = 0;
  loading: boolean = true;
  saving: boolean = false;
  editModel: PublicHolidayGroupEditModel = PublicHolidayGroupEditModel.fromJS({});
  globalGroups: PublicHolidayGroupViewModel[] = [];

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage, params: {id: this.id.toString()} });
  }

  created() {
    this.id = parseInt(this.$route.params.id);
  }

  async mounted() {
    this.openSlideIn();
    this.globalGroups = await stPublicHolidayGroupApi.getList(PublicHolidayGroupFilter.fromJS({ isGlobal: true }));
    this.editModel = this.id == 0 ? await stPublicHolidayGroupApi.getNew() : await stPublicHolidayGroupApi.get(this.id);
    this.loading = false;
  }

  async submit() {
    try {
      this.saving = true;
      if (this.id == 0) {
        this.id = await stPublicHolidayGroupApi.post(this.editModel);
      } else {
        await stPublicHolidayGroupApi.put(this.id, this.editModel);
      }
      notifySuccess("Erfolgreich gespeichert");
      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
